<app-page><div class="grid">
    <div class="col-12 md:col-8 m-auto my-5">
        <p-card>
            <app-liferay-content [contentId]="contentId"></app-liferay-content>
        </p-card>
    </div>
</div>
</app-page>